import configHelper from '@/config/ConfigHelper'
import { i18n } from '@/i18n'

function GenerateConfig () {
  return [
    {
      id: 'F',
      name: i18n.t('tipos.persona.fisica_short')
    },
    {
      id: 'J',
      name: i18n.t('tipos.persona.juridica_short')
    },
  ]
}

export function TIPOS_PERSONA (state) {
  return configHelper.getConfig(state, 'TIPOS_PERSONA', GenerateConfig)
}
